import { get, isEqual, negate } from 'lodash-es';
import { EMPTY_STRING } from '@is24at/react-constants';

const splitGacValues = (nextValue: any) => {
  const getZipCode = (value) => {
    if (isEqual(get(value, 'type'), 'zipCode')) {
      return get(value, 'value', EMPTY_STRING);
    }
    if (isEqual(get(value, 'type'), 'postcode')) {
      return get(value, 'zipCode', EMPTY_STRING);
    }

    return EMPTY_STRING;
  };

  const zipCode = getZipCode(nextValue);
  const region = negate(isEqual)(get(nextValue, 'type'), 'zipCode')
    ? get(nextValue, 'value', EMPTY_STRING)
    : EMPTY_STRING;
  const spot = get(nextValue, 'label', EMPTY_STRING);

  return { zipCode, region, spot };
};

export default splitGacValues;
